<template>
	<div>
		<div class="row">
			<div class="mb-3" v-if="tabName=='clearingcash' || tabName=='clearingedc' || tabName=='clearingvalpg' ">
				<el-collapse>
					<el-collapse-item>
						<template slot="title">
							<span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
						</template>
						<el-form label-position="top" label-width="100px">
							<div class="row" v-if="tabName=='clearingcash' || tabName=='clearingedc'">
								<div class="col-md-6">
									<el-form-item label="Search:">
										<el-select v-model="stationid" clearable filterable placeholder="Select" size="medium" style="width:100%;">
											<el-option v-for="item3 in spbu.list" :key="item3.StationId" :label="item3.StationName" :value="item3.StationId">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
							</div>

							<div class="row" v-if="tabName=='clearingcash' || tabName=='clearingedc'">
								<div class="col-md-4">
									<el-form-item label="Station:">
										<el-radio-group v-model="detail1" size="small">
											<el-radio-button :label="item2.value" v-for="(item2, index2) in options.detail1" :key="'station_'+item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

								<div class="col-md-8">
									<el-form-item label="Type:">
										<el-radio-group v-model="type" size="small">
											<el-radio-button :label="item2.value" v-for="(item2, index2) in options.type" :key="'type_'+item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

							</div>

							<div class="row" v-if="tabName=='clearingcash' || tabName=='clearingedc' || tabName == 'clearingvalpg'">
								<div class="col-md-4">
									<el-form-item :label="tabName=='clearingedc' ? 'Settlement Date:' : 'Date:' ">
										<div class="block">
											<el-date-picker
											v-model="dateRange"
											type="daterange"
											align="right"
											size="small"
											unlink-panels
											range-separator="-"
											start-placeholder="Start date"
											end-placeholder="End date"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											:picker-options="pickerOptions">
											</el-date-picker>
										</div>
									</el-form-item>
								</div>

								<div class="col-md-8">
									<el-form-item label="Status:">
										<el-radio-group v-model="status" size="small">
											<el-radio-button :label="item2.value" v-for="(item2, index2) in options.status" :key="'status_'+item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

							</div>

                            <div class="row">
                                <div class="col-md-12" v-if="tabName == 'clearingcash' || tabName == 'clearingedc'">
                                    <el-form-item label="Region">
                                        <el-radio-group v-model="region" size="small" name="region">
                                            <el-radio-button :label="item5.value" v-for="(item5, index5) in options.region" :key="'region_'+item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                        </el-radio-group>
                                    </el-form-item>
                                </div>
                            </div>

							<div class="row" v-if="tabName=='clearingcash' || tabName=='clearingedc' || tabName == 'clearingvalpg'">
								<div class="col-md-4">
									<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
								</div>

								<div class="col-md-4 mt-0" v-if="(tabName=='clearingcash' || tabName=='clearingedc') && $store.getters.getLoginInfo.userroles.indexOf('MOD2023100005_1') != -1">
									<el-button type="primary" size="medium" :loading="loading.syncData" @click="applySyncData" style="width:100%;">Sync Data</el-button>
								</div>
							</div>

						</el-form>
					</el-collapse-item>
				</el-collapse>
			</div>

			<div class="mt-0">
				<ReportResultTable :reportname="'FinanceReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/>
			</div>
		</div>

		<el-dialog
			ref="dialog"
			title="Sync Data"
			:visible.sync="loadingDialogVisibility"
			:close-on-click-modal="false"
			width="30%"
			center>
			<div>
				<div class="row text-center">
					<div class="col-md-12 mt-4">
						<Loader/>
					</div>
				</div>
				<div class="row text-center mt-5">
					<div class="col-md-12">
						<div class="row">
							<div class="col-md-12">
								<span>Please wait...</span><br>
								<span style="font-size:15px;">{{ formattedTime }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer" v-if="false">
				<el-button @click="loadingDialogVisibility = false">Cancel</el-button>
				<el-button type="primary" @click="loadingDialogVisibility = false">Confirm</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>

import FinanceReport from '@/components/page/FinanceReport.js'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { Penanggalan, AxiosWithJar, Config} from '@/utility.js'
//import Loader from '@/components/loader/Loader.vue'
import Loader from '@/components/loader/Loader2.vue'

//import * as ChartGeo from 'chartjs-chart-geo'

export default
{
	extends: FinanceReport,
	props: ['tabIndex','tabName', 'tabLabel'],
	components: {
		//ReportParamSelect,
		ReportResultTable,
		//LineChart,
		//BarChart,
		//PieChart,
		Loader,
	},

	data(){
		return {
			date: {
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin,
			},
			options: {
				detail1:[
					{ value: "", name: "ALL" },
					{ value: "station", name: "BY STATION" },
				],
				type:[
					{ value: "", name: "ALL" },
					{ value: "SPBU", name: "SPBU" },
					{ value: "SPBU-T", name: "SPBU-T" },
					{ value: "MODULAR", name: "MODULAR" },
					{ value: "PERTASHOP", name: "PERTASHOP" },
					{ value: "SHELTER", name: "SHELTER" },
					{ value: "SPBG", name: "SPBG" },
				],
				status:[
					{ value: "", name: "ALL" },
					{ value: "CLEARED", name: "CLEARED" },
					{ value: "UNCLEARED", name: "UNCLEARED" },
				],
                region:[
					{ value: "", name: "ALL" },
					//{ value: "region", name: "BY REGION", field: "RegionPertareId" },
					{ value: "1", name: "1" },
					{ value: "2", name: "2" },
					{ value: "3", name: "3" },
					{ value: "4", name: "4" },
					{ value: "5", name: "5" },
					{ value: "6", name: "6" },
					{ value: "7", name: "7" },
				],
			},

			loading: {
				table: false,
				chart: false,
				isSuccess: false,
				syncData: false,
			},

			loadingDialogVisibility :  false,
			startTime: 0,
			totalSeconds: 0,
			currentTime: 0,
			interval: null,

			dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().kemarin, this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin],

			charttype: 'linechart', //barchart //linechart
			showchart: false,
			stationList: [],
			//tabIndex: this.$route.query.tab ? this.$route.query.tab : 0,
			reportdata: [],
			chartdata: [],
			piechartdata: [],
			showchartupdate: false,
			showchartstoreupdate: false,
			stacked: true,
			stationid: this.$route.query.station ? this.$route.query.station : '',
			area: this.$route.query.area ? this.$route.query.area : '',
            update: this.$route.query.update ? this.$route.query.update : '',
			urlRequestParams: '',

			spbu:{ data:{}, list:[], types:[] },
			dt : this.$route.query.dt ? this.$route.query.dt : Penanggalan().bulanKemarin,
			//segment : this.$route.query.segment ? this.$route.query.segment : "1",
			//level : this.$route.query.level ? this.$route.query.level : "1",
			station: this.$route.query.station ? this.$route.query.station : '',
			detail1: this.$route.query.detail1 ? this.$route.query.detail1 : '',
			region: this.$route.query.region ? this.$route.query.region : '',
			type: this.$route.query.type ? this.$route.query.type : 'SPBU',
			status: this.$route.query.status ? this.$route.query.status : 'UNCLEARED',
			do_reload : 1,

			pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},

			isFirstLoad: true,
			limit: 100,

		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },

	},
    mounted() {
        //this.$emit('childrenRoute');
		Array.from(document.querySelectorAll('aside li.nav-item a')).map((e)=>{e.classList.remove('active')})
        document.querySelector('li.nav-item a.'+window.location.pathname.split('/')[1]).classList.add('active')
        this.$emit('childrenRoute')
        //this.searchFilterButtonClick()
		//this.loadSegment();
		//console.log(this.finance.segment)
		this.reload();
		this.loadStationList()

        if(this.region) {
            this.dateRange = [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang, this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin],
            this.loadFinanceData();
        }

		//add if clearing
    },
    methods:{
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')
		},
		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		},

		reload() {
			this.do_reload = this.do_reload * -1;
		},

		async loadFinanceData() {
			this.urlRequestParams=Config().apiURL
			if (this.tabName == 'clearingcash') //0
				this.urlRequestParams+='/finance/dcreport?'
			else if (this.tabName == 'clearingedc') //1
				this.urlRequestParams+='/v1/finance/kliringedc?'
			else if (this.tabName == 'clearingvalpg')
				this.urlRequestParams+='/v1/finance/kliringvalpg?'

			this.urlRequestParams+='&date-range-start='+ (this.dateRange && this.dateRange[0] ? this.dateRange[0] : '') //Penanggalan().kemarin
			this.urlRequestParams+='&date-range-end='+ (this.dateRange && this.dateRange[1] ? this.dateRange[1] : '')

			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End
			this.urlRequestParams+='&station='+this.stationid
			this.urlRequestParams+='&area='+this.station
			this.urlRequestParams+='&region='+this.region
			this.urlRequestParams+='&status='+this.status
            this.urlRequestParams+='&type='+this.type
            this.urlRequestParams+='&detail1='+this.detail1
            this.urlRequestParams+='&limit='+this.limit

			///set to 0 (no limit) after first load
			this.limit = 0

			this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.reportdata = response.data;
					this.loading.isSuccess = true;
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})

        },

		//load all station
		async loadStationList() {
			let url = Config().apiURL + "/fuel2/station?";
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data.length){
					this.spbu.list = result.data.data;
				}
			})
		},

		syncData() {
			let url = Config().apiURL + "/finance/sync?";
			AxiosWithJar().get(url)
				.then(()=>{
					//this.reportdata = response.data;
					//this.loading.isSuccess = true;
					this.stopTimer()
					this.resetTimer()

					this.$message({
						message: 'Success, sync data berhasil.',
						type: 'success'
					});

					this.loadFinanceData()

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
					this.messageBox()
				})
				.finally(() => {
					this.loadingDialogVisibility = false
				})
		},

        syncDataClearingEdc() {
			//let url = "http://ptprkpapp24:8033/Dashboard/SyncKliringEDC?"; //Config().apiURL + "/finance/sync?";
            let url = Config().apiURL + "/v1/finance/syncclearingedc?";
			url += '&start-date=' + (this.dateRange && this.dateRange[0] ? this.dateRange[0] : Penanggalan().bulanSekarang)
			url += '&end-date=' + (this.dateRange && this.dateRange[1] ? this.dateRange[1] : Penanggalan().kemarin)
            AxiosWithJar().get(url)
				.then(()=>{
					//this.reportdata = response.data;
					//this.loading.isSuccess = true;
					this.stopTimer()
					this.resetTimer()

					this.$message({
						message: 'Success, sync data berhasil.',
						type: 'success'
					});

					this.loadFinanceData()

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
					this.messageBox()
				})
				.finally(() => {
					this.loadingDialogVisibility = false
				})
		},

		confirmDialog() {
			this.$confirm(
				'Proses ini akan membutuhkan waktu sekitar 10 menit atau lebih, apakah ingin melanjutkan ?',
				'Warning',
				{
					confirmButtonText: 'Process',
					cancelButtonText: 'Cancel',
					//type: 'warning',
					beforeClose: (action, instance, done) => {
						if (action === 'confirm') {
							this.loadingDialogVisibility = true
							done()

                            if(this.tabName == 'clearingedc')
                                this.syncDataClearingEdc()
                            else
                                this.syncData()

							this.startTimer()
						} else {
							done()
							this.stopTimer()
							this.resetTimer()
						}
					}
				}
			)
			.then(() => {
			this.$message({
				type: 'success',
				message: 'Process Started'
			});
			}).catch(() => {
			this.$message({
				type: 'info',
				message: 'Process canceled'
			});
			});
		},

		messageBox() {
			this.$alert("Process failed. Please try again.", 'Error', {
			confirmButtonText: 'OK',
			callback: function () {
				this.$message({
				type: 'info',
				message: `Please try again.`
				})
			}
			});
		},

		startTimer() {
			this.resetTimer()
          if (!this.interval) {
            this.startTime = Math.floor(Date.now() / 1000);
			this.currentTime = 0
            this.interval = setInterval(() => {
              this.currentTime = Math.floor(Date.now() / 1000);
            }, 1000);
          }
        },
        stopTimer() {
			clearInterval(this.interval);
			this.interval = null;
		},
        resetTimer() {
			clearInterval(this.interval);
			this.interval = null;
			this.startTime = 0;
			this.currentTime = 0;
        },

		applyFilter() {
			this.loadFinanceData()
        },

		applySyncData() {
			this.confirmDialog()
			//this.loadingDialogVisibility = true
		},

    },
    computed: {
		formattedTime() {
          const elapsedSeconds = Math.floor(this.currentTime - this.startTime);
          const minutes = Math.floor((elapsedSeconds % 3600) / 60);
          const seconds = elapsedSeconds % 60;/*
          return hours.toString().padStart(2, '0') + ":" +
                 minutes.toString().padStart(2, '0') + ":" +
                 seconds.toString().padStart(2, '0');
				 */
		return minutes.toString().padStart(2, '0') + ":" +
			seconds.toString().padStart(2, '0');
        },
    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
